module.exports = __webpack_public_path__ + "565670ffab0dab8de5191e61c0ebe156.png";